import type { Moment } from "moment";
import moment from "moment";

/**
 * Adjusts the endDate to comply with the maximum allowed range of 3 months and 1 hour.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns An object containing the adjusted startDate and endDate.
 */
export function adjustDateRange(startDate: Moment, endDate: Moment): { startDate: string; endDate: string } {
  const maxEndDate = moment(startDate).add(3, "months").add(1, "hour");
  if (moment(endDate).isAfter(maxEndDate)) {
    return {
      startDate: startDate.set({ h: startDate.hour(), m: startDate.minutes(), s: startDate.seconds() }).format(),
      endDate: maxEndDate.set({ h: maxEndDate.hour(), m: maxEndDate.minutes(), s: maxEndDate.seconds() }).format(),
    };
  }
  return {
    startDate: startDate.set({ h: startDate.hour(), m: startDate.minutes(), s: startDate.seconds() }).format(),
    endDate: endDate.set({ h: endDate.hour(), m: endDate.minutes(), s: endDate.seconds() }).format(),
  };
}
